import { accommodationRateZodObject } from "@@/shared/acquire/accommodation-rate";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const editRateCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("EDIT_RATE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    productId: productIdZodSchema,
    providerId: providerIdZodSchema,
    rate: accommodationRateZodObject,
});

type EditRateCommand = z.infer<typeof editRateCommandZodObject>;

const editRateCommandFactoryParamsZodObject = editRateCommandZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});
type FactoryParams = z.infer<typeof editRateCommandFactoryParamsZodObject>;

const editRateCommandFactory = (params: FactoryParams) => {
    const editRateCommand: EditRateCommand = {
        ...params,
        _id: generateId({ prefix: "edit_rate_command__" }),
        _type: "EDIT_RATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
        rate: {
            ...params.rate,
            // the first rates created didn't have a _createdAt field
            // so we'll add it here if it's missing
            _createdAt: params.rate._createdAt ?? nowIsoAndUnix(),
            options: params.rate.options.map(option => ({
                ...option,
                // the first rate options created didn't have a _createdAt field
                // so we'll add it here if it's missing
                _createdAt: option._createdAt ?? nowIsoAndUnix(),
            })),
        },
    };
    return editRateCommand;
};

export {
    editRateCommandFactory,
    editRateCommandFactoryParamsZodObject,
    editRateCommandZodObject,
};
export type { EditRateCommand, FactoryParams as editRateCommandFactoryParams };
